import React, { useState } from "react";
import { isAuthenticated, AddTelephone, deleteUserTelephone, checkUserTelephone } from "../auth";
import { MdRadioButtonChecked, MdDeleteForever } from "react-icons/md";
import { FaPhone, FaCheckCircle, FaCheckSquare } from "react-icons/fa";
import { Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import PhoneInput, { parsePhoneNumber, formatPhoneNumber, formatPhoneNumberIntl, isValidPhoneNumber, getCountryCallingCode } from 'react-phone-number-input';
import en from 'react-phone-number-input/locale/en.json';
import 'react-phone-number-input/style.css';
import { elakayAutoText } from "../pageInside/dataElakay";
import "../pageInside/profileAddressPhoneModals.css";

const AddTelephonePage = (props) => {
    const {
        infoSource,
        handePage
    } = props;

    const {
        phoneUser,
        setPhoneUser,
        readUser,
        getButtonTitle
    } = infoSource;

    const { token } = isAuthenticated();
    const [value, setValue] = useState();
    // Real bug fix (redesign): clickSubmit had no submitting guard (a fast
    // double click fired two identical AddTelephone requests) and its
    // error branch was a totally empty `if (data.error) {}` block -- any
    // failure (including a future duplicate-phone rejection, spec §15)
    // vanished silently with zero feedback.
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");
    const [saved, setSaved] = useState(false);

    // Styles CSS Premium
    const premiumStyles = `
/* ===== ANIMATIONS PREMIUM ===== */
@keyframes phonePageEnter {
    from {
        opacity: 0;
        transform: translateY(30px) scale(0.97);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes phoneCardSlideIn {
    from {
        opacity: 0;
        transform: translateY(20px) rotateX(5deg);
    }
    to {
        opacity: 1;
        transform: translateY(0) rotateX(0deg);
    }
}

@keyframes shimmerGlow {
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
}

@keyframes badgeFloat {
    0%, 100% {
        transform: translateY(0) scale(1);
    }
    50% {
        transform: translateY(-3px) scale(1.02);
    }
}

@keyframes pulseGlow {
    0%, 100% {
        box-shadow: 0 4px 16px rgba(0, 164, 216, 0.3);
    }
    50% {
        box-shadow: 0 6px 24px rgba(0, 164, 216, 0.5);
    }
}

@keyframes phoneRing {
    0%, 100% {
        transform: rotate(0deg);
    }
    10%, 30%, 50%, 70%, 90% {
        transform: rotate(-10deg);
    }
    20%, 40%, 60%, 80% {
        transform: rotate(10deg);
    }
}

/* Page animation */
.phone-page-premium {
    animation: phonePageEnter 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

/* Cards stagger */
.phone-card-wrapper {
    animation: phoneCardSlideIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.phone-card-wrapper:nth-child(1) { animation-delay: 0.05s; }
.phone-card-wrapper:nth-child(2) { animation-delay: 0.1s; }
.phone-card-wrapper:nth-child(3) { animation-delay: 0.15s; }
.phone-card-wrapper:nth-child(4) { animation-delay: 0.2s; }
.phone-card-wrapper:nth-child(5) { animation-delay: 0.25s; }
.phone-card-wrapper:nth-child(6) { animation-delay: 0.3s; }
.phone-card-wrapper:nth-child(7) { animation-delay: 0.35s; }
.phone-card-wrapper:nth-child(8) { animation-delay: 0.4s; }

/* ===== CONTAINER PREMIUM ===== */

.row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"] {
    border-radius: 24px !important;
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.95) 0%, 
            rgba(248, 250, 252, 0.98) 100%
        ) !important;
    backdrop-filter: blur(20px);
    box-shadow: 
        0 20px 60px rgba(0, 115, 153, 0.15),
        0 0 0 1px rgba(255, 255, 255, 0.8),
        inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;
    border: 1px solid rgba(226, 232, 240, 0.8) !important;
    overflow: hidden;
    position: relative;
}

/* Shimmer background */
.row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"]::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
        circle at center,
        rgba(0, 164, 216, 0.06) 0%,
        transparent 60%
    );
    animation: shimmerGlow 10s linear infinite;
    pointer-events: none;
    z-index: 0;
}

.row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"] > * {
    position: relative;
    z-index: 1;
}

/* Header */
.row.mt-4.mb-4.justify-content-center .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"],
.row.mt-4.mb-4.justify-content-center .col.col-12[style*="backgroundColor: WhiteSmoke"] {
    background: 
        linear-gradient(135deg, 
            rgba(0, 115, 153, 0.1) 0%, 
            rgba(0, 164, 216, 0.08) 100%
        ),
        linear-gradient(180deg, 
            rgba(255, 255, 255, 0.9) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        ) !important;
    border-bottom: 2px solid transparent !important;
    border-image: linear-gradient(90deg, 
        transparent 0%, 
        rgba(0, 164, 216, 0.4) 50%,
        transparent 100%
    ) 1 !important;
    padding: 2rem 1rem !important;
}

.row.mt-4.mb-4.justify-content-center .col.col-12[style*="backgroundColor: WhiteSmoke"] h4,
.row.mt-4.mb-4.justify-content-center .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] h4 {
    background: linear-gradient(135deg, 
        #006b8a 0%, 
        #007399 25%,
        #00a4d8 50%,
        #007399 75%,
        #006b8a 100%
    );
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 800;
    margin: 0;
    animation: shimmerGlow 3s linear infinite;
}

/* ===== PHONE INPUT PREMIUM ===== */

.phone-page-premium .PhoneInput {
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.98) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        );
    backdrop-filter: blur(10px);
    border: 2px solid rgba(226, 232, 240, 0.8);
    border-radius: 14px;
    padding: 0.875rem 1.25rem;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 
        0 2px 8px rgba(0, 115, 153, 0.06),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.phone-page-premium .PhoneInput:focus-within {
    outline: none;
    border-color: rgba(0, 164, 216, 0.6);
    background: #ffffff;
    box-shadow: 
        0 0 0 4px rgba(0, 164, 216, 0.1),
        0 4px 16px rgba(0, 115, 153, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 1);
    transform: translateY(-2px);
}

.phone-page-premium .PhoneInputInput {
    border: none;
    background: transparent;
    font-size: 1rem;
    color: #1e293b;
    outline: none;
}

.phone-page-premium .PhoneInputInput::placeholder {
    color: #94a3b8;
}

.phone-page-premium .PhoneInputCountry {
    margin-right: 1rem;
}

/* ===== PHONE CARDS PREMIUM ===== */

.phone-card-wrapper {
    min-width: 310px;
    padding: 0.75rem;
}

.phone-page-premium .card {
    border-radius: 18px;
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.98) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        );
    backdrop-filter: blur(10px);
    border: 1px solid rgba(226, 232, 240, 0.6);
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 
        0 4px 16px rgba(0, 115, 153, 0.08),
        0 0 0 1px rgba(255, 255, 255, 0.5),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    position: relative;
    min-width: 300px;
    padding: 1.25rem;
}

.phone-page-premium .card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(0, 164, 216, 0.05) 0%, 
        transparent 50%
    );
    opacity: 0;
    transition: opacity 0.4s ease;
    pointer-events: none;
}

.phone-page-premium .card:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 
        0 20px 40px rgba(0, 115, 153, 0.2),
        0 0 0 1px rgba(0, 164, 216, 0.3),
        0 0 60px rgba(0, 164, 216, 0.1);
    border-color: rgba(0, 164, 216, 0.4);
}

.phone-page-premium .card:hover::before {
    opacity: 1;
}

/* Phone card content */
.phone-page-premium .card p {
    margin: 0.5rem 0;
    color: #1e293b;
    font-size: 0.9375rem;
    font-weight: 500;
}

.phone-page-premium .card p:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #64748b;
    font-size: 0.875rem;
}

.phone-page-premium .card p.mx-auto {
    text-align: center;
    font-size: 1.125rem;
    font-weight: 700;
    color: #007399;
    margin: 1rem 0;
    letter-spacing: 0.02em;
}

/* Default badge */
.phone-page-premium .float-right {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    background: linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%);
    color: #ffffff;
    padding: 0.35rem 0.75rem;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(56, 189, 248, 0.3);
    animation: badgeFloat 2s ease-in-out infinite;
}

/* ===== CIRCLE BUTTONS PREMIUM ===== */

.phone-page-premium .btn[style*="width: 30px"] {
    width: 36px !important;
    height: 36px !important;
    padding: 0 !important;
    border-radius: 50% !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 1.1rem !important;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
    border: none !important;
    position: relative !important;
    overflow: hidden !important;
}

.phone-page-premium .btn[style*="width: 30px"]::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(255, 255, 255, 0.3) 0%, 
        transparent 100%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
}

.phone-page-premium .btn[style*="width: 30px"]:hover::before {
    opacity: 1;
}

/* Check button */
.phone-page-premium span.btn[style*="width: 30px"]:not(:last-child) {
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 2px 8px rgba(0, 115, 153, 0.3) !important;
}

.phone-page-premium span.btn[style*="width: 30px"]:not(:last-child):hover {
    transform: scale(1.2) !important;
    box-shadow: 0 4px 16px rgba(0, 115, 153, 0.5) !important;
}

/* Delete button */
.phone-page-premium span.btn[style*="width: 30px"]:last-child {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3) !important;
}

.phone-page-premium span.btn[style*="width: 30px"]:last-child:hover {
    transform: scale(1.2) rotate(-15deg) !important;
    box-shadow: 0 4px 16px rgba(239, 68, 68, 0.5) !important;
}

/* ===== ACTION BUTTONS ===== */

.phone-page-premium .btn-outline-info {
    padding: 0.875rem 2rem !important;
    border-radius: 14px !important;
    font-weight: 700;
    font-size: 1rem;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    overflow: hidden;
    border: none;
}

.phone-page-premium .btn-outline-info::before {
    content: '';
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.4s ease;
    pointer-events: none;
}

/* Close button */
.phone-page-premium .btn-outline-info.float-left {
    background: 
        linear-gradient(135deg, 
            rgba(241, 245, 249, 0.98) 0%, 
            rgba(226, 232, 240, 0.95) 100%
        );
    color: #475569;
    box-shadow: 
        0 4px 12px rgba(71, 85, 105, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.phone-page-premium .btn-outline-info.float-left::before {
    background: linear-gradient(135deg, 
        rgba(148, 163, 184, 0.2) 0%, 
        transparent 100%
    );
}

.phone-page-premium .btn-outline-info.float-left:hover {
    background: 
        linear-gradient(135deg, 
            rgba(226, 232, 240, 0.98) 0%, 
            rgba(203, 213, 225, 0.95) 100%
        );
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(71, 85, 105, 0.25);
    color: #334155;
}

.phone-page-premium .btn-outline-info.float-left:hover::before {
    opacity: 1;
}

/* Add Phone button */
.phone-page-premium .btn-outline-info.float-right {
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%);
    color: #ffffff;
    box-shadow: 
        0 4px 16px rgba(0, 164, 216, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.2);
    animation: pulseGlow 2s ease-in-out infinite;
}

.phone-page-premium .btn-outline-info.float-right::before {
    background: linear-gradient(135deg, 
        rgba(255, 255, 255, 0.3) 0%, 
        transparent 100%
    );
}

.phone-page-premium .btn-outline-info.float-right:hover {
    background: linear-gradient(135deg, #006b8a 0%, #007399 100%);
    transform: translateY(-4px) scale(1.05);
    box-shadow: 
        0 12px 32px rgba(0, 164, 216, 0.5),
        0 0 40px rgba(0, 164, 216, 0.2);
}

.phone-page-premium .btn-outline-info.float-right:hover::before {
    opacity: 1;
}

/* Phone icon animation */
.phone-page-premium .btn-outline-info.float-right:hover span[style*="fontSize: 20px"] {
    animation: phoneRing 0.5s ease-in-out;
}

/* Disabled button */
.phone-page-premium .btn-outline-info.disabled {
    background: linear-gradient(135deg, 
        rgba(203, 213, 225, 0.5) 0%, 
        rgba(148, 163, 184, 0.5) 100%
    );
    color: #94a3b8;
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
    animation: none;
}

.phone-page-premium .btn-outline-info.disabled:hover {
    transform: none;
    box-shadow: none;
}

/* ===== RESPONSIVE ===== */

@media (max-width: 768px) {
    .row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"] {
        border-radius: 20px !important;
    }

    .row.mt-4.mb-4.justify-content-center .col.col-12[style*="backgroundColor: WhiteSmoke"],
    .row.mt-4.mb-4.justify-content-center .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] {
        padding: 1.5rem 1rem !important;
    }

    .phone-card-wrapper {
        padding: 0.5rem;
    }

    .phone-page-premium .card {
        padding: 1rem;
        border-radius: 16px;
    }

    .phone-page-premium .btn[style*="width: 30px"] {
        width: 32px !important;
        height: 32px !important;
        font-size: 1rem !important;
    }

    .phone-page-premium .btn-outline-info {
        padding: 0.75rem 1.5rem !important;
        font-size: 0.9375rem;
        border-radius: 12px !important;
    }

    .phone-page-premium .PhoneInput {
        padding: 0.75rem 1rem;
        border-radius: 12px;
    }
}

/* ===== REDUCED MOTION ===== */

@media (prefers-reduced-motion: reduce) {
    .phone-page-premium,
    .phone-card-wrapper,
    .phone-page-premium .card,
    .phone-page-premium .btn,
    .row.mt-4.mb-4.justify-content-center .col.col-12[style*="backgroundColor: WhiteSmoke"] h4,
    .phone-page-premium .float-right {
        animation: none !important;
        transition: none !important;
    }
}
`;

    const DeleteTelephone = (id) => {
        deleteUserTelephone(token, id).then(response => {
            if (response.error) {
            } else {
                readUser(token);
            }
        });
    };

    const CheckDefaultTelephone = id => {
        checkUserTelephone(token, id).then(response => {
            if (response.error) {
            } else {
                readUser(token);
            }
        });
    };

    const canSubmit = value && isValidPhoneNumber(value) && !submitting;

    const clickSubmit = () => {
        if (!canSubmit) return; // double-submit guard (spec §18/§30 "Double click")
        const data = {
            "country": en[parsePhoneNumber(value).country],
            "abrCountry": parsePhoneNumber(value).country,
            "ariaCode": getCountryCallingCode(parsePhoneNumber(value).country),
            "National": formatPhoneNumber(value),
            "International": formatPhoneNumberIntl(value)
        };
        setSubmitting(true);
        setError("");
        setSaved(false);
        AddTelephone(token, data).then(data => {
            setSubmitting(false);
            if (data.error) {
                // Real bug fix: this branch used to be a totally empty `{}`
                // block -- any failure (network, validation, or a future
                // duplicate-phone rejection, spec §15) vanished silently.
                // Never surface data.error verbatim if it ever contained raw
                // Mongo text -- but AddTelephone's own backend
                // (AddPhoneUser) doesn't touch the unique telephoneSing
                // index at all, so today this only ever carries a clean,
                // already-controlled message.
                setError(data.error);
            } else {
                readUser(token);
                setValue("");
                setSaved(true);
            }
        });
    };

    const TelephoneButton = () => (
        <div className="epm-actions">
            <button type="button" className="epm-btn epm-btn-cancel" disabled={submitting} onClick={() => handePage()}>
                {infoSource.laguangeElakay('Button', infoSource.languageAPI).close}
            </button>
            <button type="button" className="epm-btn epm-btn-primary" disabled={!canSubmit} onClick={clickSubmit}>
                {submitting
                    ? <><span className="epm-spin" aria-hidden="true">⟳</span>{elakayAutoText("h_epm_saving", "Saving…")}</>
                    : <><FaPhone aria-hidden="true" />{infoSource.laguangeElakay('Button', infoSource.languageAPI).addPhone}</>}
            </button>
        </div>
    );

    const deleteButtonTelephone = id => {
        return (
            <span onClick={() => DeleteTelephone(id)} className="btn btn-info float-right mr-4" style={{ width: "30px", height: "30px", padding: 0, textAlign: "center", fontSize: "1.2rem", borderRadius: "50%" }} data-toggle="tooltip" data-placement="top" title={getButtonTitle("deletePhone")}>
                <MdDeleteForever />
            </span>
        );
    };

    const checkButtonTelephone = (id, address) => (
        address ?
            <span className="btn btn-info float-right mr-4" style={{ width: "30px", height: "30px", padding: 0, textAlign: "center", fontSize: "1.2rem", borderRadius: "50%" }} data-toggle="tooltip" data-placement="top" title={getButtonTitle("phoneCheckedByDefault")}>
                <FaCheckCircle />
            </span>
            : <>
                <span onClick={() => CheckDefaultTelephone(id)} className="btn btn-info float-right mr-4" style={{ width: "30px", height: "30px", padding: 0, textAlign: "center", fontSize: "1.2rem", borderRadius: "50%" }} data-toggle="tooltip" data-placement="top" title={getButtonTitle("addDefaultPhone")}>
                    <MdRadioButtonChecked />
                </span>
            </>
    );

    const buttonEditDelete = (id, addressDefault) => (
        <div className="row justify-content-center">
            <div className="bg clearfix">
                {checkButtonTelephone(id, addressDefault)}
                {deleteButtonTelephone(id)}
            </div>
        </div>
    );

    const AddressUser = (
        phoneUser?.length > 0 && (
            <div className="row mt-4 mb-4 justify-content-center phone-page-premium">
                <style>{premiumStyles}</style>
                <div className="col col-12 col-md-10" style={{ border: "1px solid Gainsboro" }}>
                    <div className="col col-12" style={{ textAlign: "center", backgroundColor: "WhiteSmoke" }}>
                        <h4>{infoSource.laguangeElakay('title', infoSource.languageAPI).yourPhoneNumber}</h4>
                    </div>
                    <div className="container-fluid">
                        <Row xs={2} sm={2} md={3} lg={4} xl={5}>
                            {
                                phoneUser?.map((m, i) => (
                                    <div key={i} className="phone-card-wrapper">
                                        <div className="card">
                                            <p>
                                                {m.country}
                                                {m.default && (
                                                    <span className="float-right">
                                                        <FaCheckSquare />{infoSource.laguangeElakay('label', infoSource.languageAPI).default}
                                                    </span>
                                                )}
                                            </p>
                                            <p className="mx-auto">{m.International}</p>
                                            {buttonEditDelete(m._id, m.default)}
                                        </div>
                                    </div>
                                ))
                            }
                        </Row>
                        <div></div>
                    </div>
                </div>
            </div>
        )
    );

    const phoneInvalid = value && !isValidPhoneNumber(value);

    // Real reference implementation for this exact component -- the
    // [FLAG][COUNTRY CODE][NUMBER] input is react-phone-number-input's
    // <PhoneInput> itself (spec §11/§12), same country/dial-code source
    // (react-phone-number-input/locale/en.json) already used by every
    // other phone form in Elakay (userAddingRoleByToken's own telephone
    // forms) -- not a second country/phone system.
    const countryTelephone = () => (
        <div className="phone-page-premium">
            <style>{premiumStyles}</style>
            {error && <div className="epm-alert-danger" role="alert">{error}</div>}
            {saved && !error && (
                <div className="epm-banner" role="status">
                    <FaCheckCircle aria-hidden="true" />
                    <span>{elakayAutoText("h_epm_phoneSaved", "Phone number saved successfully.")}</span>
                </div>
            )}
            <div className={`epm-field epm-phone-field${phoneInvalid ? " epm-field-invalid" : ""}`}>
                <label htmlFor="epm-phone-input">{infoSource.laguangeElakay('label', infoSource.languageAPI).phone}</label>
                {/* Phone input restored to its 2026-07-26 version (same as the
                    2026-06-22 commit): react-phone-number-input's own flag
                    country selector. `id` only links the label above. */}
                <PhoneInput
                    id="epm-phone-input"
                    countrySelectProps={{ unicodeFlags: true }}
                    placeholder={infoSource.laguangeElakay('label', infoSource.languageAPI).enterPhoneNumber}
                    value={value}
                    onChange={(next) => { setValue(next); if (error) setError(""); }}
                    error={value ? (isValidPhoneNumber(value) ? undefined : 'Invalid phone number') : 'Phone number required'}
                />
                {phoneInvalid
                    ? <p id="epm-phone-error" className="epm-field-error">{elakayAutoText("h_epm_invalidPhone", "Please enter a valid phone number.")}</p>
                    : <p id="epm-phone-hint" className="epm-field-hint">{elakayAutoText("h_epm_phoneHint", "We'll use this number for account-related communication.")}</p>}
            </div>
            {TelephoneButton()}
        </div>
    );

    return (
        <>
            <Modal show={saved} onHide={() => {}} backdrop="static" keyboard={false} centered aria-labelledby="phone-added-title">
                <Modal.Header>
                    <Modal.Title id="phone-added-title">{elakayAutoText("h_checkout_phoneAddedTitle", "Phone Number Added Successfully")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{elakayAutoText("h_checkout_phoneAddedBody", "Your phone number is now available for this checkout.")}</p>
                </Modal.Body>
                <Modal.Footer className="epm-actions">
                    <button type="button" className="epm-btn epm-btn-secondary" onClick={() => setSaved(false)}>
                        {elakayAutoText("h_checkout_addAnotherPhone", "Add Another Phone Number")}
                    </button>
                    <button type="button" className="epm-btn epm-btn-secondary" onClick={() => { setSaved(false); handePage("pageAddress"); }}>
                        {elakayAutoText("h_checkout_addAddress", "Add Address")}
                    </button>
                    <button type="button" className="epm-btn epm-btn-primary" onClick={() => handePage()}>
                        {elakayAutoText("h_checkout_done", "Done")}
                    </button>
                </Modal.Footer>
            </Modal>
            {countryTelephone()}
            {AddressUser}
        </>
    );
};

export default AddTelephonePage;
